import React from "react";
import "../../chat/animate/slide_top.css"
import "../../chat/animate/slide_in_right.css";
import './user.scss'; // 导入样式文件
const User = ({ content }) => {
    return (
        <div className="user_message slide-in-right">
            <span className="user_message_text">{content}</span>
        </div>
    )
}
export default User;